import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import HtmlAppletForm from './HtmlAppletForm';
import htmlAppletService from '../../services/htmlAppletService';

const HtmlAppletCreate = (props: any) => {
  const { onSave = null, navigateBack = true, handleCancel = null } = props;

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);

  const { checkPermission } = useCheckPermission();

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    htmlAppletService
      .create({
        name: entity.name,
        htmlContent: entity.htmlContent,
        file: entity.file,
        responsibilityAccepted: entity.responsibilityAccepted,
      })
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? ['Ismeretlen hiba']);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Sikeres mentés!', {
            variant: 'success',
          });

          if (onSave) onSave(response.result);
          if (navigateBack) navigate('/htmlApplets');
        }
      })
      .catch((err) => {
        const message =
          err?.response?.data?.title ||
          err?.response?.data?.detail ||
          err?.message ||
          'Mentés sikertelen';
        setErrors([message]);
        enqueueSnackbar(message, { variant: 'error' });
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <HtmlAppletForm
      entity={{
        id: '',
        name: '',
        htmlContent: '',
        contentUrl: null,
        packageUrl: null,
      }}
      readonly={!checkPermission(['CreateHtmlApplet'])}
      onSubmit={onSubmit}
      errors={errors}
      handleCancel={() =>
        handleCancel != null ? handleCancel() : navigate('/htmlApplets')
      }
    />
  );
};

export default HtmlAppletCreate;
